import {get} from 'lodash-es';

const getUserAttributes = (state) => get(state, 'userAttributes.data', null);
const getIsUserAttributesLoading = (state) => get(state, 'userAttributes.is_loading', false);

export {getUserAttributes, getIsUserAttributesLoading};
